import React, { useState } from "react";
import { motion } from "framer-motion";
import { X, Gift } from "lucide-react";
import { UserData } from "../../store/dreamworldSlice";

interface TipCreatorModalProps {
  creator: UserData;
  onClose: () => void;
  onSendTip: (amount: number) => void;
}

const TipCreatorModal: React.FC<TipCreatorModalProps> = ({
  creator,
  onClose,
  onSendTip,
}) => {
  const [amount, setAmount] = useState(10);

  const handleSendTip = () => {
    onSendTip(amount);
    onClose();
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50"
    >
      <div className="bg-gray-800 rounded-lg shadow-xl w-full max-w-sm p-6">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold text-white">Tip {creator.username}</h2>
          <button onClick={onClose} className="p-2 text-gray-400 hover:text-white">
            <X size={24} />
          </button>
        </div>
        <div className="text-center">
          <Gift size={48} className="text-yellow-400 mx-auto mb-4" />
          <p className="text-gray-300 mb-4">
            Show your appreciation for {creator.username}'s work!
          </p>
          <div className="flex items-center justify-center space-x-2 my-4">
            <input
              type="number"
              value={amount}
              onChange={(e) => setAmount(parseInt(e.target.value))}
              className="w-24 p-2 bg-gray-700 rounded text-white text-center"
            />
            <span className="text-white font-bold">FLUX</span>
          </div>
          <button
            onClick={handleSendTip}
            className="w-full bg-yellow-500 hover:bg-yellow-600 text-white font-bold py-3 rounded-lg transition-colors"
          >
            Send Tip
          </button>
        </div>
      </div>
    </motion.div>
  );
};

export default TipCreatorModal;
